var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "c--shared_user-box display-flex align-items-center justify-content-start px-20 px-md-30 py-20 py-md-30 bg-white"
  }, [_c('h3', {
    staticClass: "typo-h3 typo-md-h2 mb-0 display-flex flex-column justify-content-center align-items-start"
  }, [_c('span', {
    attrs: {
      "data-testid": "account-name"
    }
  }, [_vm._v(_vm._s(_vm.userName) + " ")]), _vm._v(" "), _vm.userRankTitle ? [_c('span', {
    staticClass: "typo-checkbox typo-md-p font-weight-normal color-text-secondary mt-10"
  }, [_vm._v(_vm._s(_vm.userRankTitle))])] : _vm._e()], 2), _vm._v(" "), _vm.userRanImageUrl ? [_c('Badge', {
    staticClass: "ltr:tw-ml-auto rtl:tw-mr-auto",
    attrs: {
      "image-url": _vm.userRanImageUrl
    }
  })] : _vm._e()], 2);

}
var staticRenderFns = []

export { render, staticRenderFns }